import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { notification } from "antd";
import { Strings } from "../../../../../dataProvider/localize";
import { deleteSwmsDraftV2 } from "../../../../../actions/v2/JobSwmsTaskActions";
import styles from "./SwmsDeleteConfirmModal.module.css";

const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" className={styles.infoBannerIcon}>
    <path d="M136.7 5.9L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-8.7-26.1C306.9-7.2 294.7-16 280.9-16L167.1-16c-13.8 0-26 8.8-30.4 21.9zM416 144L32 144 53.1 467.1C54.7 492.4 75.7 512 101 512L347 512c25.3 0 46.3-19.6 47.9-44.9L416 144z" />
  </svg>
);

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor" className={styles.closeBtnIcon}>
    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z" />
  </svg>
);

export default function SwmsDeleteConfirmModal({ swms, jobId, onClose }) {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const formName = swms && swms.swms_form_name ? swms.swms_form_name : "SWMS";
  const formId = swms && swms.swms_form_id ? swms.swms_form_id : "N/A";

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget && !submitting) {
      onClose();
    }
  };

  const handleDelete = () => {
    if (!swms || !swms.swms_form_id || !jobId) {
      notification.error({
        message: Strings.error_title,
        description: Strings.generic_error,
        className: "ant-error"
      });
      onClose();
      return;
    }

    setSubmitting(true);
    dispatch(deleteSwmsDraftV2(jobId, swms.swms_form_id)).then((message) => {
      setSubmitting(false);
      notification.success({
        message: Strings.success_title,
        description: message || "SWMS deleted successfully.",
        className: "ant-success"
      });
      onClose();
    }).catch((err) => {
      setSubmitting(false);
      notification.error({
        message: Strings.error_title,
        description: err || Strings.generic_error,
        className: "ant-error"
      });
    });
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.headerText}>
            <h3>Delete SWMS</h3>
            <p className={styles.headerSubtitle}>{formName} · {formId}</p>
          </div>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            disabled={submitting}
            type="button"
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>

        <div className={styles.body}>
          <div className={styles.infoBanner}>
            <TrashIcon />
            <span>
              Are you sure you want to delete this SWMS draft? This action cannot be undone.
            </span>
          </div>
          <p className={styles.warningText}>
            This will permanently remove the selected SWMS draft from this job.
          </p>
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button type="button" className={styles.deleteBtn} onClick={handleDelete} disabled={submitting}>
            {submitting ? <CircularProgress size={16} style={{ color: "#fff" }} /> : "Delete SWMS"}
          </button>
        </div>
      </div>
    </div>
  );
}
